import styled from '@emotion/styled'
import { Theme } from '@yuno/design-system-web'
import { IInstructions } from '../../interfaces/connection.interfaces'
import { useTranslation } from 'react-i18next'

type ConnectionSetupInstructionTitleProps = {
  instruction: IInstructions
  instructionType: string
  credentials?: boolean
}

type StyledProps = { theme?: Theme; styles?: React.CSSProperties }

const Url = styled('a')<StyledProps>`
  color: ${({ theme }) => theme.palette.vivid.brand};
  overflow-wrap: break-word;
`
const SpanStyled = styled('span')<StyledProps>`
  white-space: nowrap;
`

const Li = styled('li')(({ credentials }: { credentials: boolean }) => ({
  marginBottom: credentials ? 0 : '20px',
}))

export const ConnectionSetupInstructionTitle = ({
  instruction,
  instructionType,
  credentials,
}: ConnectionSetupInstructionTitleProps) => {
  const isEmptyType = instructionType === ''
  const isLink = instruction?.type === 'link'

  const { t, i18n} = useTranslation()
  const currentLanguage = i18n.language;
  const hasTranslations = typeof instruction?.text !== 'string'

  const textValue = hasTranslations ? instruction.text[currentLanguage.toLocaleUpperCase()] as string : instruction?.text
  const textLink = hasTranslations ? instruction?.text_link[currentLanguage.toLocaleUpperCase()] as string : instruction?.text_link

  if (isLink) {
    let textDivided = textValue.split(textLink)
    const text = (
      <div>
        <SpanStyled>{textDivided?.[0]}{' '}</SpanStyled>
        {textLink.length > 30 && <br/>}
        <Url href={instruction?.link} target="_blank">
          {textLink}
        </Url>
        {textDivided?.[1]}
      </div>
    )
    return isEmptyType ? <>{text}</> : <Li credentials={credentials}>{text}</Li>
  }

  if (isEmptyType) {
    return <>{textValue}</>
  }

  return <Li credentials={credentials}>{textValue}</Li>
}
